export const FETCH_PROFILE_DATA = "fetch_profile_data"
export const PROFILE_DATA_FETCH_SUCCESS = "profile_data_fetch_success"
export const PROFILE_DATA_FETCH_FAILURE = "profile_data_fetch_failure"

export const CLEAR_FETCHED_PROFILE_DATA = "clear_fetched_profile_data"
export const SAVE_PROFILE_DATA = "save_profile_data"
